import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetCurrentAccountErrorAction implements Action {
  public static readonly type = 'GetCurrentAccountErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetCurrentAccountErrorAction.type;
}
